import * as actions from "store/actions/subscription/create";
import ISubscription, { SubscriptionStatus } from "Types/Subscription";
import dayjs from "dayjs";

export interface SubscriptionCreateState extends ISubscription {
	loading: boolean;
	errors: any;
	user: any;
}

interface MyAction {
	type: string;
	payload: any;
}

const initialState: SubscriptionCreateState = {
	loading: false,
	value: "",
	discount: "",
	installment: "1",
	installmentInterval: "30",
	description: "",
	user: null,
	plan: "",
	paymentMethod: "",
	firstPayment: dayjs(),
	status: SubscriptionStatus.enabled,
	errors: {}
};

const reducer = function (state = initialState, action: MyAction) {
	const { type, payload } = action;
	switch (type) {
		case actions.CREATE_SUBSCRIPTION: {
			return {
				...state,
				loading: true,
				errors: initialState.errors
			};
		}
		case actions.CREATE_SUBSCRIPTION_SUCCESS: {
			return {
				...initialState
			};
		}
		case actions.CREATE_SUBSCRIPTION_FAILED: {
			return {
				...state,
				loading: false,
				errors: payload
			};
		}
		case actions.SET_VALUE:
			return {
				...state,
				...payload
			};
		case actions.CLEAR_VALUES:
			return {
				...initialState
			};
		default: {
			return state;
		}
	}
};

export default reducer;
